/*
 *  Copyright (c) 2018-present, Evgeny Nadymov
 *
 * This source code is licensed under the GPL v.3.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
import React from 'react';
import createSvgIcon from '@material-ui/core/esm/utils/createSvgIcon';

export default createSvgIcon(
    <g transform='translate(3.000000, 0.600000)'>
        <path
            d='M9,0 C13.9705627,-9.13077564e-16 18,4.02943725 18,9 L18,23 L18,23 L15,20 L12,23 L9,20 L6,23 L3,20 L0,23 L0,9 C-6.08718376e-16,4.02943725 4.02943725,9.13077564e-16 9,0 Z'
            stroke='currentColor'
            strokeWidth='1.5'
            strokeLinejoin='round'
            fill='none'
        />
        <circle cx='5' cy='9' r='2' />
        <circle cx='13' cy='9' r='2' />
    </g>,
    'DeletedAccount'
);
